import { ButtonProps } from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { useCallback, useMemo, useState } from "react";
import { Dialog } from "../../Dialog";

type DialogNewAdvertisingProps = {
  loading?: boolean;
  open: boolean;
  onClose: () => void;
  onSave: (data: string) => void;
};

export function DialogNewAdvertising({
  loading,
  open,
  onClose,
  onSave,
}: DialogNewAdvertisingProps) {
  const [advertising, setAdvertising] = useState<string>("");

  const handleSave = useCallback(() => {
    onSave(advertising);
  }, [advertising, onSave]);

  const actions: ButtonProps[] = useMemo(() => {
    return [
      {
        children: "Fechar",
        onClick: onClose,
      },
      {
        children: loading ? "Enviando solicitação..." : "Salvar",
        onClick: handleSave,
        variant: "contained",
        disabled: loading,
      },
    ];
  }, [onClose, handleSave, loading]);

  return (
    <Dialog
      onClose={onClose}
      fullWidth
      maxWidth="md"
      title="Nova propaganda"
      open={open}
      actions={actions}
    >
      <Stack py={2}>
        <TextField
          label="Nome da propaganda"
          autoFocus
          value={advertising}
          onChange={({ target: { value } }) => setAdvertising(value)}
          fullWidth
          size="small"
        />
      </Stack>
    </Dialog>
  );
}
